import { render, staticRenderFns } from "./Liked.vue?vue&type=template&id=65e7141e&scoped=true&"
import script from "./Liked.vue?vue&type=script&lang=js&"
export * from "./Liked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7141e",
  null
  
)

export default component.exports